import React from 'react';
interface StickyMobileButtonProps {
  onClick: () => void;
}
export const StickyMobileButton: React.FC<StickyMobileButtonProps> = ({
  onClick
}) => {
  // Format today's date in Dutch format (e.g., "10 nov")
  const getTodayDate = () => {
    const today = new Date();
    const day = today.getDate();
    const monthNames = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
    const month = monthNames[today.getMonth()];
    return `${day} ${month}`;
  };
  return <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white shadow-lg border-t-2 border-gray-200 flex flex-col items-center" data-id="element-362">
      <p className="text-sm text-gray-600 mb-2" data-id="element-363">
        Vandaag {getTodayDate()} • 10:00, 13:00 of 20:00
      </p>
      <button onClick={onClick} className="w-full md:w-auto bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-6 rounded-lg transition duration-200 shadow-md" data-id="element-364">
        Gratis Webinar: Communiceren Met Je Hond (zonder straffen)
      </button>
    </div>;
};